import { preview } from '@/components/form/preview'
import { useEditingStateWithCtx } from '@/atoms'

import { OrderAvatar } from '../../../../components/OrderAvatar'
import { PreviewActions } from './components/PreviewActions'
import { PreviewTabs } from '../../../../components/shared/PreviewTabs'
import { useActions } from './hooks/useActions'

interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
  tab: number
  setTab: (tab: number) => void
}

export function Header(props: Props) {
  const { extOrder, tab, setTab } = props

  const actions = useActions()
  const { editing } = useEditingStateWithCtx('order')

  const subtitle = extOrder.atDepot
    ? extOrder.depot.name
    : extOrder.location.address || extOrder.location.geoAddress || ''

  return (
    <preview.Header
      title={extOrder.order.name}
      subtitle={subtitle}
      testId="order-view-header"
      avatar={<OrderAvatar extendedOrderStep={extOrder} style={{ marginRight: 16 }} size={42} />}
      onClose={actions.onReset}
    >
      <PreviewActions tab={tab} extOrder={extOrder} />

      <PreviewTabs tab={tab} setTab={setTab} testIdPrefix="order-form-tab__" disabled={editing} />
    </preview.Header>
  )
}
